import React from 'react';

import { FieldType } from '@/components/Form';
import CheckboxFieldEditorConfig from '@/modules/corporate/modules/database/fields/checkbox/Editor/config';
import { DatabaseFieldEditorConfig } from '@/modules/corporate/modules/database/fields/types';

import SelectFormEditorOptionsList from '../components/SelectFormEditorOptionsList';

const SelectFieldEditorConfig: DatabaseFieldEditorConfig = {
  getFieldSettingsFormProps: CheckboxFieldEditorConfig.getFieldSettingsFormProps,
  getFieldSettingsFormInitialValues: CheckboxFieldEditorConfig.getFieldSettingsFormInitialValues,
  adaptEditorFormField: ({ allowPartialUpdates, field }) => ({
    type: FieldType.SlowCustom,
    Component: () => (
      <SelectFormEditorOptionsList allowPartialUpdates={allowPartialUpdates} field={field} />
    ),
  }),
};

export default SelectFieldEditorConfig;
